import React, { useState, useEffect } from 'react';
import './style.css';
import { Device } from '../../../../types/Device';
import { useAuthStore } from '../../../../store/auth/auth';
import { ONLINE_PLAY_LAYOUT_URL, ONLINE_PLAY_URL } from '../../../../const/const';
import { useOnlineStateStream } from '../../../../store/devices/onlineStream';
import foto from './Video.png';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface PlayerPlaceProps {
    device: Device | null;
}

const PlayerPlace: React.FC<PlayerPlaceProps> = ({ device }) => {
    const { SmartDVRToken } = useAuthStore();
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const getFilePlayUrl = (uid: string, authToken: string) => {
        if (!device || !authToken) return '';
        return `${ONLINE_PLAY_URL}${uid}/${authToken}`; // Со звуком
        // return `${ONLINE_PLAY_LAYOUT_URL}${uid}/${authToken}`;
    };

    const videoSrc = device ? getFilePlayUrl(device.UID, SmartDVRToken) : '';

    useEffect(() => {
        // Сброс состояния при изменении устройства
        setIsLoading(true);
        setHasError(false);

        if (!videoSrc || (device && !device.online)) {
            setIsLoading(false);
            setHasError(true);
            return;
        }

        // Имитация загрузки плеера
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1500); // Минимальное время показа спиннера

        return () => clearTimeout(timer);
    }, [videoSrc, device?.UID, device?.online]);

    const handleIframeLoad = () => {
        setIsLoading(false);
        setHasError(false);
    };

    const handleIframeError = () => {
        setIsLoading(false);
        setHasError(true);
    };

    if (device && !device.online) {
        return (
            <div className="noVideo">
                <img src={foto} alt="Устройство не в сети" />
                {/*<p className="error-message">Устройство не в сети</p>*/}
            </div>
        );
    }

    return (
        <div className="PlayerPlace">
            {isLoading ? (
                <div className="player-loading">
                    <Spin
                        indicator={<LoadingOutlined style={{ fontSize: 200 }} spin />}
                        tip="Загрузка трансляции..."
                    />
                </div>
            ) : hasError || !videoSrc ? (
                <div className="noVideo">
                    <img src={foto} alt="Устройство не в сети" />
                    <p className="error-message">
                        {device?.online ? 'Плеер недоступен' : 'Устройство не в сети'}
                    </p>
                </div>
            ) : (
                <iframe
                    width="100%"
                    height="100%"
                    src={videoSrc}
                    scrolling="no"
                    frameBorder="0"
                    style={{ borderWidth: '0px', borderRadius: 8 }}
                    allowFullScreen={true}
                    onLoad={handleIframeLoad}
                    onError={handleIframeError}
                    title={`Плеер устройства ${device?.name}`}
                />
            )}
        </div>
    );
};

export default PlayerPlace;
